/** Visual pitch only (snap-to-grid stays GRID_SIZE in canvasUtils). */
export const FLOWCHART_VISUAL_DOT_PITCH = 28;

/** SVG tile pattern (one circle per cell); avoids full-canvas radial-gradient repaint cost */
export const FLOWCHART_DOT_GRID_BG = (() => {
  const n = FLOWCHART_VISUAL_DOT_PITCH;
  const c = n / 2;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${n}" height="${n}"><circle cx="${c}" cy="${c}" r="0.85" fill="rgba(255,255,255,0.125)"/></svg>`;
  return `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;
})();
